import { SchedulerClinicalSpecialistsSettings } from '@lp/features/Scheduler';
import { SchedulerSettingsPageHeader } from '@lp/features/Scheduler/components';

export const CSSchedulerSettings = () => {
  return (
    <div className="flex flex-col p-6 gap-6 min-h-full">
      <SchedulerSettingsPageHeader backLinkPath="/schedule/cs" />
      <SchedulerClinicalSpecialistsSettings />
    </div>
  );
};
